import { z } from 'zod';
/**
 * Der Antwortvertrag der Nummernkreise — `V-vertrag3` (2026-08-29).
 *
 * `apps/api/src/number-ranges/number-range.service.ts` führte
 * `NumberRangeView` bislang als eigene Form; der OpenAPI-Erzeuger blieb an
 * `GET /api/v1/number-ranges` deshalb `[UNGEKLÄRT]`.
 */
/** Ein Nummernkreis, wie ihn die Oberfläche und die Meldungen brauchen. */
export const numberRangeViewSchema = z
    .object({
    key: z.string(),
    purpose: z.string(),
    /** Untergrenze. `bigint`, deshalb Zeichenkette. */
    minValue: z.string(),
    /** Obergrenze, einschliessend. */
    maxValue: z.string(),
    /** Auf wie viele Stellen die Nummer aufgefüllt wird. Ein Zählwert, kein Geld. */
    width: z.number().int().positive(),
    /** Ist dieser Kreis für Sachkonten gesperrt? */
    reservedForAccounts: z.boolean(),
    note: z.string().nullable(),
})
    .strict();
/**
 * Die Antworthülle von `GET /api/v1/number-ranges` — `{ ranges: [...] }`. Der Umschlag lebt neben seinem
 * Elementschema, damit Server und Oberfläche dieselbe Hülle prüfen (Handbuch §3.969).
 */
export const numberRangeListResponseSchema = z.object({ ranges: z.array(numberRangeViewSchema).readonly() }).strict();
//# sourceMappingURL=number-ranges.js.map